import type { PropsWithChildren } from 'react';
import React, { createContext } from 'react';

export type TableRowIndex = string | number;

export interface IContextProps {
  activeRow?: TableRowIndex;
  setActiveRow: React.Dispatch<React.SetStateAction<TableRowIndex | undefined>>;
  isCollapsedNav?: boolean;
}

interface TableProviderProps extends PropsWithChildren {
  isCollapsedNav?: boolean;
}

const TableContext = createContext({} as IContextProps);

const TableProvider: React.FC<TableProviderProps> = ({ isCollapsedNav, children }) => {
  const [activeRow, setActiveRow] = React.useState<TableRowIndex | undefined>(undefined);

  const value = React.useMemo(
    () => ({
      activeRow,
      setActiveRow,
      isCollapsedNav,
    }),
    [activeRow, setActiveRow, isCollapsedNav],
  );

  return <TableContext.Provider value={value}>{children}</TableContext.Provider>;
};

const useTableContext = (): IContextProps => {
  const value = React.useContext(TableContext);
  if (!value) {
    throw new Error('`useTableContext` is used outside `TableContext.Provider`');
  }
  return value;
};

export { useTableContext, TableProvider };
